export enum VehicleCommand {
    Lock = 'Lock',
    Unlock = 'Unlock',
}

export function isValidVehicleCommand(value: unknown): value is VehicleCommand {
    const allowedCommands = [VehicleCommand.Lock, VehicleCommand.Unlock];

    return allowedCommands.includes(value as VehicleCommand);
}